import { FormStateNumber, useComplaint } from "./useComplaint";
import { FormComplaint } from "../../Molecules/Forms/FormComplaint/formComplaint";
import { UploadFile } from "../../Molecules/UploadFilePage/uploadFilePage";
import * as S from "./styles";
import { StatusSuccessPage } from "../statusSuccessPage/statusSuccessPage";
import { IDenunciaForm } from "../../../types/denuncia";
type FormStepComponentProps = {
  handleSubmit?: (data: IDenunciaForm) => void;
  setFormState: (n: FormStateNumber) => void;
};
type FormStepComponent = (props?: FormStepComponentProps) => JSX.Element;

const formSteps: Record<number, FormStepComponent> = {
  1: (props) => <FormComplaint hanldleSubmit={props.handleSubmit} />,
  2: (props) => <UploadFile handleNext={props.setFormState} />,
  3: () => <StatusSuccessPage />,
};

export const Complaint = () => {
  const { formState, handleSubmit, setFormState } = useComplaint();

  const StepComponent = formSteps[formState];

  return (
    <S.Container>
      {formState !== 3 && (
        <div>
          <h1>Canal de Denúncias</h1>
        </div>
      )}
      {StepComponent && StepComponent({ handleSubmit, setFormState })}
    </S.Container>
  );
};
